import { type InvestmentBalance } from 'investments/common/entities'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

const TWO_MINUTES = 60 * 1000 * 2

type AccountDetailsResponse = {
  balance: InvestmentBalance
  bucketCount: number
  defaultBucketId: string
  hasInvestedBefore: boolean
  journey: 'needs_question_us_person' | 'available' | 'needs_onboarding' | 'not_available'
  ownerUsPerson: boolean
  showOnboarding: boolean
  currentBankingAccountBalance: number
}

async function fetchAccountDetails({ accountId }: { accountId: string }) {
  const { data } = await httpClientBanking<AccountDetailsResponse>({
    url: `/investments/accounts/${accountId}`
  })
  return data
}

export function getUseFetchAccountDetailsKey({ accountId }: { accountId: string }) {
  return ['useFetchAccountDetails', accountId] as const
}

export function useFetchAccountDetails({
  accountId,
  options
}: {
  accountId: string
  options?: { suspense?: boolean }
}) {
  return useQueryRequest<Awaited<ReturnType<typeof fetchAccountDetails>>, unknown, true>(
    [...getUseFetchAccountDetailsKey({ accountId })],
    () => fetchAccountDetails({ accountId }),
    {
      suspense: true,
      refetchInterval: TWO_MINUTES,
      refetchIntervalInBackground: true,
      ...options
    }
  )
}
